var exports = {
  "T": "issueTypeDot__93cmVB",
};

module.exports = exports;
